import React from 'react'
import TalksSection from '../components/TalksSection'
import BooksSection from '../components/BooksSection'

import encouraging from '../assets/images/encouraging.png'
import delegationDial from '../assets/images/delegation-dial.png'
import checkin from '../assets/images/checkin.jpg'
import goldenCircle from '../assets/images/golden-circle.jpg'
import diversityMakesYourTeamThumbnail from '../assets/images/diversity-makes-your-team-thumbnail.jpg'
import influencerCover from '../assets/images/influencer-cover.jpg'
import crucialConversationsCover from '../assets/images/crucial-conversations-cover.jpg'

const books = [
  {
    title: 'Influencer',
    link: 'https://www.amazon.com/Influencer-Science-Leading-Change-Second/dp/0071808868',
    description: 'Whether you\'re a CEO, a parent, or merely a person who wants to make a difference, you probably wish you had more influence with the people in your life. But most of us stop trying to make change happen because we believe it is too difficult, if not impossible. We learn to cope rather than learning to influence.',
    image: {
      src: influencerCover,
      alt: 'Influencer book cover'
    }
  },
  {
    title: 'Crucial Conversations',
    link: 'https://www.amazon.com/Crucial-Conversations-Talking-Stakes-Second/dp/0071771328',
    description: 'When stakes are high, opinions vary, and emotions run strong, you have three choices: Avoid a crucial conversation and suffer the consequences; handle the conversation badly and suffer the consequences; or read Crucial Conversations and discover how to communicate best when it matters most. Crucial Conversations gives you the tools you need to step up to life\'s most difficult and important conversations, say what\'s on your mind, and achieve the positive resolutions you want.',
    image: {
      src: crucialConversationsCover,
      alt: 'Crucial Converstations book cover'
    }
  }
]

const talks = [
  {
    title: 'How Diversity Makes Your Team More Innovative',
    link: 'https://www.ted.com/talks/rocio_lorenzo_want_a_more_innovative_company_hire_more_women/up-next?language=en',
    description: 'Are diverse companies really more innovative? Rocío Lorenzo and her team surveyed 171 companies to find out -- and the answer was a clear yes. In a talk that will help you build a better, more robust company, Lorenzo dives into the data and explains how your company can start producing fresher, more creative ideas by treating diversity as a competitive advantage.',
    image: {
      src: diversityMakesYourTeamThumbnail,
      alt: 'How Diversity Makes Your Team More Innovative video thumbnail'
    }
  }
]
const EncouragingInitiative = () => (
  <div>
    <section id="one" className="main style1">
      <div className="grid-wrapper">
        <div className="col-6">
          <header className="major">
            <h2>Encouraging Initiative</h2>
          </header>
          <ul>
            <li>Be tolerant of failure: support people on their mistakes</li>
            <li>Seeking different perspectives when solving problems</li>
            <li>Suggesting new ways of completing assignments</li>
          </ul>
        </div>
        <div className="col-6">
          <span className="image fit">
            <img src={encouraging} alt="Image of girl encouraging another girl" />
          </span>
        </div>
      </div>
    </section>

    <section id="three" className="main style3 special">
      <div className="grid-wrapper">
        <div className="col-12">
          <header className="major">
            <h2>Learning Materials</h2>
          </header>
        </div>

        <div className="col-4">
          <h3>Delegation</h3>
          <ul style={{ textAlign: 'left' }}>
            <li><a target="_blank" href="https://drive.google.com/open?id=1fymGpXXeICcrmSfrm59vpCgGKpYs8zV4">For delegation to work, it has to come with coaching</a></li>
          </ul>
        </div>
        <div className="col-4">
          <h3>Leadership</h3>
          <ul style={{ textAlign: 'left' }}>
            <li><a target="_blank" href="https://naspers.udemy.com/leadership-how-to-create-their-walk-in-the-door-moments/">Leadership: How to create their "Walk in the Door" moments</a></li>
            <li><a target="_blank" href="">Leadership: How to influence, inspire and impact as a leader</a></li>
          </ul>
        </div>
        <div className="col-4">
          <h3>Feedback</h3>
          <ul style={{ textAlign: 'left' }}>
            <li><a target="_blank" href="https://drive.google.com/open?id=1WjvOjVuaz6_3WHK40gZUKjK2z30_vvqd">Give your team more effective positive feedback</a></li>
          </ul>
        </div>
      </div>
    </section>

    <section id="four" className="main style1 special">
        <header className="major">
          <h2>Check Lists</h2>
        </header>
      <div className="grid-wrapper">
        <div className="col-2"></div>
        <div className="col-8">
        <ul style={{ listStyle: 'square', textAlign: 'left' }}>
          <li>PI in place for every team member, and updated every 6 month - will allow you to know better your team</li>
          <li>Development group and also individual meetings with employees (PDPs) - explaining and sharing the strategy, goals, vision, OKRs - <a href="https://drive.google.com/drive/u/0/folders/16zqQvx8lGviHIhKN12-2KBpIyxkvxINn">Check-In Conversations</a></li>
          <li>Be part of the Top Leader Program (ELT)</li>
          <li>Work in Certified Coaching Programs, and also in partnership with Human Resources Business Partner</li>
          <li><a target="_blank" href="https://medium.com/@speakerhubHQ/8-storytelling-techniques-to-use-on-stage-d3fd1c326adf">Storytelling Techniques</a> will help you <a href="https://www.sparkol.com/en/Blog/November-2014/8-Classic-storytelling-techniques-for-engaging-presentations">engaging and mentoring</a> your team</li>
          <li>Create and promote webinars between Managers to share knowledge and best practices - <a target="_blank" href="https://plus.google.com/communities/105929568250712989224">Live it!</a> is one channel, e.g; through Zoom or <a target="_blank" href="https://www.docebo.com/knowledge-base/webinar/">other platforms</a></li>
          <li>OKRs/Goals based on company needs, agreed with employees</li>
          <li><a target="_blank" href="https://bpg.co.za/our-programmes/">Design Thinking Model</a> - Participlan will challenge your thinking (and from your team) on how you structure and deliver content, to influence better results from these communication opportunities</li>
          <li>Remember and Respect the <a target="_blank" href="https://managercompanion.com/sabina-nawazs-delegation-dial/">Delegation Dial</a></li>
        </ul>
      </div>
        <div className="col-2"></div>
      </div>
    </section>

    <section id="five" className="main style3">
      <div className="grid-wrapper">
        <div className="col-6">
          <header className="major">
            <h2>Templates</h2>
          </header>
          <h4>Deletagion Dial</h4>
          <p>One of the challenges of delegation is that it often gets boiled down to the boilerplate, “Delegate and elevate.” This is one of those management quips that makes complete sense when one hears it, but leaves a new manager wondering, How in the world do I do that?</p>
        </div>
        <div className="col-6">
          <span className="image fit">
            <a target="_blank" href="https://managercompanion.com/sabina-nawazs-delegation-dial/">
              <img src={delegationDial} alt="Delegation Dial diagram" />
            </a>
          </span>
        </div>
        <div className="col-6">
          <h4>Check-In Conversations</h4>
          <p>These discussion guides are intended to help provide a format and talking points for employees and people managers during Check-ins. The guides are organized by the three steps of Check-in: Expectations, Feedback and Development and provide suggestions for how to have an effective discussion. They are not intended to be a script, but to provide guidelines to prepare employees and people managers before, during and after the Check-in conversation.</p>
        </div>
        <div className="col-6">
          <span className="image fit">
            <a target="_blank" href="https://www.adobe.com/content/dam/acom/en/aboutadobe/pdfs/adobe-check-in-toolkit.pdf">
              <img src={checkin} alt="Adobe Check-In image logo" />
            </a>
          </span>
        </div>

        <div className="col-6">
          <h4>Golden Circle</h4>
          <p>There are few leaders who choose to inspire rather than manipulate in order to motivate people. Whether individuals or organisations, all these inspiring leaders think, act and communicate in exactly the same way. And it’s the complete opposite of the rest of us. Consciously or not, how they do it is by following a naturally occurring pattern that Simon Sinek calls The Golden Circle.</p>
        </div>
        <div className="col-6">
          <span className="image fit">
            <a target="_blank" href="https://www.youtube.com/watch?time_continue=46&v=IPYeCltXpxw">
              <img src={goldenCircle} alt="Golden Circle diagram" />
            </a>
          </span>
        </div>
      </div>
    </section>

    <section id="six" className="main style1 special">
      <header className="major">
        <h2>Guiding Questions</h2>
      </header>
      <div className="grid-wrapper">
        <div className="col-6">
          <h4 className="highlight-title-dark">Ask Yourself:</h4>
          <ul style={{ textAlign: 'left' }}>
            <li>What are your strongest motivators to come to work everyday?</li>
            <li>Are you providing the conditions for encouraging initiative?</li>
            <li>Are you looking for a way to equip employees with the self - insight, knowledge, skills and tools they can apply the very next day, to drive initiative?</li>
            <li>Do you behave in a consistent and impactful way that drives a culture and encourages initiative?</li>
            <li>Do you feel capable to overcome challenges to encourage initiative (e.g., risk aversion, failure to produce ideas)?</li>
            <li>Do you  take a strategic approach to develop and encourage initiative?</li>
            <li>Are our leaders a positive model when it comes to encouraging initiative, or do they fail to use new approaches themselves?</li>
          </ul>
        </div>

        <div className="col-6">
          <h4 className="highlight-title-light">Ask Your Team:</h4>
          <ul style={{ textAlign: 'left' }}>
            <li>What are your strongest motivators to come to work everyday?</li>
            <li>Do You Feel Like Your Organization Encourages You To Give Your Opinion?</li>
            <li>Do You Think That Your Peers Welcome Opinions That Are Different From Their Own?</li>
            <li>Do team members fail to take ownership for their particular role and responsibilities on the team?</li>
            <li>Do you know what resources they need and how to acquire them to be more proactive?</li>
          </ul>
        </div>
      </div>
    </section>

    <BooksSection books={books} darkBg={true} />

    <TalksSection talks={talks} />
  </div>
)

export default EncouragingInitiative



// WEBPACK FOOTER //
// ./src/pages/encouraging-initiative.js